import cmaApi from "../../../../../api/cmaApi";
import { appRoutes } from "../../../../../routes/routes";
import LandingList from "../../LandingList";

const TestimonialsList = () => (
  <LandingList
    config={{
      title: "CMA · Đánh giá",
      listPath: appRoutes.CMA.LANDING.TESTIMONIALS.LIST,
      addPath: appRoutes.CMA.LANDING.TESTIMONIALS.ADD,
      queryKey: "cma_landing_testimonials",
      getList: cmaApi.getLandingTestimonials,
      editItem: cmaApi.editLandingTestimonial,
      deleteItem: cmaApi.deleteLandingTestimonial,
      titleField: "name_vi",
      subtitleField: "quote_vi",
    }}
  />
);

export default TestimonialsList;
